import React from "react";
import { string } from "prop-types";
import "./event.scss";

const Event = ({
  title,
  venue,
  street,
  town,
  postcode,
  startDateTime,
  endDateTime,
  info
}) => {
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  const timeOptions = {
    timeStyle: "short",
    hour12: true
  };

  const start = new Date(startDateTime);
  const startDate = start.toLocaleDateString("en-GB", options);
  const startTime = start.toLocaleTimeString("en-GB", timeOptions);
  const end = new Date(endDateTime);
  const endTime = end.toLocaleTimeString("en-GB", timeOptions);
  const formattedDate = `${startDate} ${startTime} - ${endTime}`;

  return (
    <div className="event-item">
      <h3>{title}</h3>
      <p>{venue}</p>
      <p>
        {street}, {town}, {postcode}
      </p>
      <p className="lead">{formattedDate}</p>
      <p>{info}</p>
    </div>
  );
};

Event.propTypes = {
  title: string.isRequired,
  venue: string.isRequired,
  street: string.isRequired,
  town: string.isRequired,
  postcode: string.isRequired,
  startDateTime: string.isRequired,
  endDateTime: string.isRequired,
  info: string.isRequired
};

export default Event;
